import { Controller } from 'stimulus'

// Two-pane zone explorer (Windows-explorer style). Left = zones tree (folders),
// right = the selected zone's contents. All client-side on pre-rendered DOM.
export default class extends Controller {

  static targets = ['panel', 'crumb']

  connect() {
    const selected = this.element.dataset.selectedZone
    if (selected) this.showZone(selected)
  }

  // Click a zone in the left tree.
  select(event) {
    this.showZone(event.currentTarget.dataset.zoneId)
  }

  // Click a sub-folder row in the right pane → open it.
  openZone(event) {
    this.showZone(event.currentTarget.dataset.zoneId)
  }

  // Expand / collapse a folder in the left tree (without selecting it).
  toggle(event) {
    event.stopPropagation()
    const li = event.currentTarget.closest('.mat-explorer__node')
    const children = li && Array.from(li.children).find(el => el.matches('ul.mat-explorer__children'))
    if (!children) return
    const collapsed = children.classList.toggle('d-none')
    event.currentTarget.classList.toggle('is-open', !collapsed)
  }

  showZone(zoneId) {
    const id = String(zoneId)
    this.panelTargets.forEach(panel => panel.classList.toggle('d-none', panel.dataset.zonePanel !== id))
    this.element.querySelectorAll('.mat-explorer__zone').forEach(zone => {
      zone.classList.toggle('is-selected', zone.dataset.zoneId === id)
    })

    const zoneDiv = this.element.querySelector(`.mat-explorer__zone[data-zone-id="${id}"]`)
    if (!zoneDiv) return
    this.expandAncestors(zoneDiv)
    if (this.hasCrumbTarget) this.crumbTarget.textContent = zoneDiv.dataset.zonePath || ''
    zoneDiv.scrollIntoView({ block: 'nearest' })
  }

  expandAncestors(zoneDiv) {
    let ul = zoneDiv.closest('ul.mat-explorer__children')
    while (ul) {
      ul.classList.remove('d-none')
      const parentLi = ul.closest('.mat-explorer__node')
      const twist    = parentLi && parentLi.querySelector(':scope > .mat-explorer__zone .mat-explorer__twist')
      if (twist) twist.classList.add('is-open')
      ul = parentLi ? parentLi.parentElement.closest('ul.mat-explorer__children') : null
    }
  }
}
